module.exports = __webpack_public_path__ + "img/welfare.6727f6e9.svg";